import { render, staticRenderFns } from "./browseTask.vue?vue&type=template&id=571f6694&scoped=true&"
import script from "./browseTask.vue?vue&type=script&lang=js&"
export * from "./browseTask.vue?vue&type=script&lang=js&"
import style0 from "./browseTask.vue?vue&type=style&index=0&id=571f6694&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571f6694",
  null
  
)

export default component.exports